import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import './RadioButton.scss';

const RadioButton = ({ label = 'Label', className, disabled = false, ...props }) => {
  return (
    <label className={classNames('RadioButton', className, { disabled })}>
      <input className="form-check-input" type="radio" disabled={disabled} {...props} />

      <span className="box">
        <span className="tick" />
      </span>
      <span className="label">{label}</span>
    </label>
  );
};

RadioButton.propTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  disabled: PropTypes.bool,
  className: PropTypes.string,
};

export default RadioButton;
